import React, { useEffect, useState } from "react";
import {
  CancelButton,
  SubmitButton,
} from "../../../../Components/Utils/Buttons";
import FormikSelectTwo from "../../../../Components/Utils/Select";
import { formatDate } from "../../../../Components/Utils/NuDate";
import CloseIcon from "../../../../Components/Icons/Close";
import ImportInSchedule from "./ImportInSchedule";
import MultiInSchedule from "./MultiInSchedule";
import CustomDataTable from "../../../../Components/Others/CustomDataTable";
import ModileInSchedule from "../../../Mobile/Inspection/Schedule/ModileInSchedule";
import { GetAccess, GetNotUseRole } from "../../../../Components/Utils/roles";
import InspectionLayout from "../InspectionLayout";
import axiosInstance from "../../../../Services/axiosCommon";
import { useFormik } from "formik";
import { useLocation } from "react-router-dom";
import * as yup from "yup";
import UseGetDataSearch from "../../../../Components/Hooks/useFetchDataBySearch";
import useFetchMDIndex from "../../../../Components/Hooks/useFetchMDIndex";
import { NuDate, NuInput } from "../../../../Components/Utils/Input";

function ScheduleIndex() {
  const [screenSize, setScreenSize] = useState({
    width: window.innerWidth,
  });

  useEffect(() => {
    const handleResize = () => {
      setScreenSize({
        width: window.innerWidth,
      });
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const location = useLocation();
  const state = location.state;
  const currentPage = location.state?.currentPage;
  const [page, setPage] = useState(currentPage || 1);
  const [pageCount, setPageCount] = useState(
    localStorage.getItem("perPageView") || 20
  );
  const [filter, setFilter] = useState(state?.industry ? true : false);
  const [showFilterDialog, setShowFilterDialog] = useState(false);
  const [showExport, setShowExport] = useState(false);

  const { value: status } = useFetchMDIndex(
    `/dropdown/dropdown-details/`,
    "Status_Schedule",
    [showFilterDialog, showExport],
    () => showFilterDialog || showExport
  );

  const [filterProps, setFilterProps] = useState({
    status: "",
    dateFrom: "",
    dateTo: "",
    assigneeId: "",
    location: "",
  });
  const [params, setParams] = useState({
    page: page,
    per_page: pageCount,
    status: "",
    dateFrom: "",
    dateTo: "",
    assigneeId: "",
    location: "",
  });
  const clearFilter = () => {
    setParams({
      ...params,

      status: "",
      dateFrom: "",
      dateTo: "",
      assigneeId: "",
      location: "",
    });
    formik.values.status = "";
    formik.values.dateFrom = "";
    formik.values.dateTo = "";
    formik.values.assigneeId = "";
    formik.values.location = "";

    setFilter(false);
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: filterProps,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({}),
    onSubmit: async (value, { resetForm }) => {
      await new Promise((resolve) => setTimeout(resolve, 300)); // give Formik time to set isSubmitting

      console.log("ffff", value);
      setParams({
        ...params,
        status: value.status,
        dateFrom: value.dateFrom,
        dateTo: value.dateTo,
        assigneeId: value.assigneeId,
      });
      closeFilterDialog();
      setFilter(true);
      setFilterProps({
        status: "",
        dateFrom: "",
        dateTo: "",
        assigneeId: "",
        location: "",
      });
    },
  });
  const { data, totalCount, getData, dataLoading } = UseGetDataSearch(
    `/schedules/listing`,
    params
  );
  const [viewMode, setViewMode] = useState(
    localStorage.getItem("viewMode") || "card"
  );

  const defaultHeader = [
    {
      title: "Ref.",
      width: "10%",
      field: "refNumber",
      isLink: true,
      id: "id",
      link: `/inspection/schedule/view/`,
      textAlign: "left",
      rowAlign: "left",
    },
    GetNotUseRole("client")
      ? {
          title: "Client",
          width: "17.5%",
          isLink: true,
          id: "id",
          link: `/inspection/schedule/view/`,
          field: "clientName",
          textAlign: "left",
          rowAlign: "left",
        }
      : {
          title: " ",
          width: "0.1%",
          field: " ",
          textAlign: "left",
          rowAlign: "left",
        },
    {
      title: "Contract",
      width: "10%",
      field: "contractRefNumber",
      textAlign: "left",
      rowAlign: "left",
    },

    {
      title: "Description",
      width: "17.5%",
      field: "description",
      textAlign: "left",
      rowAlign: "left",
    },

    {
      title: "Location",
      width: "10%",
      field: "location",
      textAlign: "left",
      rowAlign: "left",
    },

    {
      title: " Inspection Date ",
      width: "10%",
      type: "date",
      field: "date",
      textAlign: "left",
      rowAlign: "left",
    },
    {
      title: "Status ",
      width: "10%",
      field: "status",
      textAlign: "left",
      rowAlign: "left",
    },

    {
      title: "Action",
      width: "10%",
      field: "action",
      textAlign: "center",
      rowAlign: "center",
      contents: {
        id: "id",
        removeValue: "refNumber",
        url: `/schedules/`,
        moduleName: "InSchedule",
        from: `/inspection/schedule`,
        editLink: `/inspection/schedule/edit/`,
        viewLink: `/inspection/schedule/view/`,
        EmailRequired: true,
        eUrl: "/schedules/",
      },
    },
  ];
  const availableHeaders = [];
  useEffect(() => {
    localStorage.setItem("viewMode", viewMode);
    setParams({ ...params, page: page, per_page: pageCount });
  }, [page, pageCount, viewMode]);

  const closeFilterDialog = () => {
    setShowFilterDialog(false);
  };
  const [showImportModal, setShowImportModal] = useState(false);

  const closeModal = () => {
    setShowImportModal(false);
  };
  const [exportValue] = useState({
    status: "",
    dateFrom: "",
    dateTo: "",
    assigneeId: "",
    location: "",
  });
  const ExportFormik = useFormik({
    enableReinitialize: true,
    initialValues: exportValue,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: async (value, { setSubmitting }) => {
      try {
        const response = await axiosInstance.get(
          `/schedules/export?assigneeId=${value.assigneeId}&dateTo=${value.dateTo}&dateFrom=${value.dateFrom}&location=${value.location}&status=${value.status}`,
          { responseType: "blob" }
        );

        const pdfBlob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(pdfBlob);
        link.download = `Schedule Report ${formatDate(new Date())}.xlsx`;

        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      } catch (error) {
        console.error("Error downloading the Excel:", error);
      } finally {
        setSubmitting(false);
      }
    },
  });

  const closeFilterDialogebox = () => {
    setShowExport(false);
  };

  const [showEdit, setShowEdit] = useState(false);
  const [listofNumbers, setListofNumbers] = useState([]);
  const [fullList, setFullList] = useState([]);

  const selectOneFunction = (value) => {
    console.log("sss", value);

    let NewId;
    if (listofNumbers && listofNumbers.some((Item) => Item === value)) {
      NewId = listofNumbers.filter((Temp) => Temp !== value);
      setListofNumbers(NewId);
    } else {
      setListofNumbers([...listofNumbers, value]);
    }
    console.log("sss", listofNumbers);
  };

  const selectMultipleFunction = (e) => {
    if (e.target.checked) {
      console.log("if List", fullList);
      setListofNumbers(fullList);
    } else {
      console.log("else List", fullList);
      setListofNumbers([]);
    }
  };

  // Define your actual API delete function for a single schedule
  const deleteSchedule = async (scheduleId) => {
    const response = await axiosInstance.delete(`/schedules/${scheduleId}`);
    return response; // Return the entire Axios response
  };

  useEffect(() => {
    let tempArr = [];
    data &&
      data.forEach((i) => {
        console.log("I", i);
        tempArr.push(i?.id);
      });
    setFullList(tempArr);
  }, [data]);

  const [valueOfSearch, setValuesofSearch] = useState("");
  function searchFunction(e) {
    setValuesofSearch(e?.target?.value);
    setParams({ ...params, search: e?.target?.value, page: 1 });
    setPage(1);
  }

  return (
    <>
      <InspectionLayout
        setOpen={setShowImportModal}
        searchFun={searchFunction}
        setOpenExport={setShowExport}
        getData={getData}
        isCard={true}
        isFilter={filter}
        newfilter={true}
        setFilterOpen={setShowFilterDialog}
        ClearFilter={clearFilter}
        CreateAccess={GetAccess("inspection_schedule_create")}
        ExportAccess={GetAccess("inspection_schedule_export")}
        searchValue={valueOfSearch}
        setViewMode={setViewMode}
        neededSearch={true}
        viewMode={viewMode}
        total={totalCount}
      >
        {screenSize.width <= "786" ? (
          <>
            <div className=" w-full h-[calc(100vh-205px)] bg-white mt-1 rounded-lg shadow-lg overflow-hidden">
              <ModileInSchedule
                data={data}
                total={totalCount}
                pageIndex={page}
                setPageIndex={setPage}
                dataCount={pageCount}
                setDataCount={setPageCount}
                getData={getData}
              />
            </div>
          </>
        ) : (
          <>
            <div className="w-full h-full ">
              <CustomDataTable
                fetcher={getData}
                data={data}
                availableHeaders={availableHeaders}
                defaultHeader={defaultHeader}
                bodyHeight="max-h-[calc(100vh-260px)]"
                height="h-[calc(100vh-160px)]"
                total={totalCount}
                pageIndex={params.page}
                setPageIndex={setPage}
                title="Inspection"
                dataCount={params.per_page}
                setDataCount={setPageCount}
                storageName="InScheduleTable"
                editAccess="inspection_schedule_edit"
                deteleAccess="inspection_schedule_delete"
                dataLoading={dataLoading}
                searchQuery={params?.search != "" ? params?.search : ""}
                hasMultiEdit={true}
                hasMultiDelete={true}
                identifierKey="refNumber"
                deleteSingleItem={deleteSchedule}
                selectOneFunction={selectOneFunction}
                setShowEdit={setShowEdit}
                showEdit={showEdit}
                listofNumbers={listofNumbers}
                selectMultipleFunction={selectMultipleFunction}
                fullList={fullList}
                getById="id"
              />
            </div>
          </>
        )}
      </InspectionLayout>

      {showFilterDialog && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
          <div className="animate-scale-in min-w-[40%] max-w-[80%] max-h-[80vh] bg-white py-4 px-6 rounded-md shadow-lg overflow-y-scroll">
            <h2 className="text-xl mb-4">Filter </h2>
            <form onSubmit={formik.handleSubmit}>
              <div className="flex flex-col mb-4">
                <p className="py-2 px-6 text-m">Inspection Date</p>

                <div className="sm:flex justify-between w-full">
                  <NuDate
                    label="From"
                    placeholder="dd/mm/yyyy"
                    formik={formik}
                    name="dateFrom"
                    width="w-full"
                  />
                  <NuDate
                    label="To"
                    placeholder="dd/mm/yyyy"
                    formik={formik}
                    name="dateTo"
                    width="w-full"
                    min={formik.values.dateFrom || ""}
                  />
                </div>

                <NuInput
                  type="text"
                  label="Location"
                  placeholder="Location"
                  formik={formik}
                  name="location"
                  width="w-full"
                />
                <FormikSelectTwo
                  label="Status"
                  Options={status}
                  formik={formik}
                  placeholder="Choose"
                  name="status"
                  width="w-full "
                />
              </div>
              <div className="flex justify-end gap-2">
                <CancelButton handleClick={closeFilterDialog} />
                <SubmitButton name="Apply" isLoading={formik.isSubmitting} />
              </div>
            </form>
          </div>
        </div>
      )}

      {showEdit && (
        <MultiInSchedule
          data={listofNumbers}
          getData={getData}
          onClose={() => setShowEdit(false)}
        />
      )}
      {showImportModal && (
        <ImportInSchedule
          show={showImportModal}
          onClose={closeModal}
          getData={getData}
        />
      )}
      {showExport && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
          <div className="animate-scale-in min-w-[85%] sm:min-w-[50%] 2xl:min-w-[40%] max-w-[50%] 2xl:max-w-[40%] max-h-[80vh] relative bg-white py-4 px-6 rounded-md shadow-lg overflow-y-scroll">
            <div className=" w-full flex justify-between items-center  bg-white">
              <h2 className=" text-sm 2xl:text-base font-medium ">
                Export Data
              </h2>
              <div
                className=" cursor-pointer "
                onClick={() => setShowExport(false)}
              >
                <CloseIcon />
              </div>
            </div>
            <form onSubmit={ExportFormik.handleSubmit}>
              <div className=" w-full flex flex-wrap">
                <div className=" w-full flex ">
                  <div className=" w-1/2 flex items-center px-6 py-3 ">
                    <input
                      id="default-radio-1"
                      type="radio"
                      value="all"
                      name="type"
                      className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300"
                      onChange={ExportFormik.handleChange}
                      checked={ExportFormik.values.type == "all"}
                    />
                    <label
                      htmlFor="default-radio-1"
                      className="ms-2 text-xs 2xl:text-sm  text-gray-900 "
                    >
                      All Data
                    </label>
                  </div>

                  <div className="w-1/2 flex items-center px-6 py-3">
                    <input
                      id="default-radio-2"
                      type="radio"
                      value="filter"
                      name="type"
                      className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300"
                      onChange={ExportFormik.handleChange}
                      checked={ExportFormik.values.type == "filter"}
                    />
                    <label
                      htmlFor="default-radio-2"
                      className="ms-2 text-xs 2xl:text-sm  text-gray-900"
                    >
                      Filter Data
                    </label>
                  </div>
                </div>
                {ExportFormik.values.type === "filter" && (
                  <>
                    <div className="sm:flex justify-between w-full">
                      <NuDate
                        label="From"
                        placeholder="dd/mm/yyyy"
                        formik={ExportFormik}
                        name="dateFrom"
                        width="w-full"
                      />
                      <NuDate
                        label="To"
                        placeholder="dd/mm/yyyy"
                        formik={ExportFormik}
                        name="dateTo"
                        width="w-full"
                        min={ExportFormik.values.dateFrom || ""}
                      />
                    </div>

                    <NuInput
                      type="text"
                      label="Location"
                      placeholder="Location"
                      formik={formik}
                      name="location"
                      width="w-full"
                    />
                    <FormikSelectTwo
                      label="Status"
                      Options={status}
                      formik={ExportFormik}
                      placeholder="Choose"
                      name="status"
                      width="w-full "
                    />
                  </>
                )}
                <div className="flex w-full justify-end gap-2">
                  <CancelButton handleClick={closeFilterDialogebox} />
                  <SubmitButton
                    name="Export"
                    isLoading={ExportFormik.isSubmitting}
                  />
                </div>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
}

export default ScheduleIndex;
